import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import * as Sentry from "@sentry/react";

// CSS
import "./styles/style.scss";

if (import.meta.env.VITE_SENTRY_ENABLED === "true") {
  Sentry.init({
    dsn: "xxxx",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    enableLogs: true,
    environment: import.meta.env.VITE_SENTRY_ENV,
    attachStacktrace: true,
    normalizeDepth: 3,
    integrations: [
      Sentry.browserSessionIntegration(),
      Sentry.contextLinesIntegration(),
      Sentry.extraErrorDataIntegration(),
      Sentry.functionToStringIntegration(),
      Sentry.httpClientIntegration(),
      Sentry.linkedErrorsIntegration(),
      Sentry.browserTracingIntegration(),
      Sentry.captureConsoleIntegration({
        levels: "error",
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ["localhost", /^https:\/\//, /lucashealth.ai/, /api/],
    // Set profilesSampleRate to 1.0 to profile every transaction.
    // Since profilesSampleRate is relative to tracesSampleRate,
    // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
    // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
    // results in 25% of transactions being profiled (0.5*0.5=0.25)
    profilesSampleRate: 1.0,
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
